export default {
  apiKey: 'AIzaSyD-usvb4DxAUtOXUFLYC6CAoY4EXRaisUk',
  authDomain: 'dietbyann-new.firebaseapp.com',
  projectId: 'dietbyann-new',
  storageBucket: 'dietbyann-new.firebasestorage.app',
  messagingSenderId: '140674980332',
  appId: '1:140674980332:web:093ec83ddc93b508ee48c9',
  measurementId: 'G-07TKSEJ5KG',
};
